import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { createQRCode } from 'store/slices/personalSlice';
import Loading from 'Components/Loading';
import { extractErrorMessage } from 'Modules/ParseAPI';

const CreateQRCodeModal = ({
  isOpen,
  toggle,
  createQRCode,
  cards
}) => {
  const {
    t
  } = useTranslation();
  // Find the Work card to use as default
  const workCard = cards.find(card => card.name === 'Work');
  const defaultCardId = workCard ? workCard.id || workCard.objectId : '';
  const [label, setLabel] = useState('');
  const [cardId, setCardId] = useState(defaultCardId);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();

    if (!label.trim()) {
      setError('QR code label is required');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await createQRCode(label.trim(), cardId || null);
      setLabel('');
      setCardId('');
      toggle();
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setLabel('');
    setCardId(defaultCardId);
    setError(null);
    toggle();
  };

  return <Modal isOpen={isOpen} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>{t("Create New QR Code")}</ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {loading && <Loading />}

                    <FormGroup>
                        <Label for="qrLabel">{t("QR Code Label")}</Label>
                        <Input type="text" id="qrLabel" value={label} onChange={e => setLabel(e.target.value)} placeholder={t("e.g., Business Card, Networking Event")} invalid={!!error} style={{
            color: '#000',
            fontWeight: 'bold'
          }} />
                    </FormGroup>

                    <FormGroup>
                        <Label for="qrCard">{t("Associated Card (Optional)")}</Label>
                        <Input type="select" id="qrCard" value={cardId} onChange={e => setCardId(e.target.value)}>
                            <option value="">{t("Use Default Card")}</option>
                            {(cards || []).filter(c => (c.name || '').toLowerCase() !== 'public').map(card => <option key={card.id || card.objectId} value={card.id || card.objectId}>
                                    {card.name ? t(card.name) : t('Card')}
                                </option>)}
                        </Input>
                    </FormGroup>

                    {error && <div className="text-danger mt-2">
                            {error}
                        </div>}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleClose} disabled={loading}>{t("Cancel")}</Button>
                    <Button color="primary" type="submit" disabled={loading || !label.trim()}>
                        {loading ? 'Creating...' : 'Create QR Code'}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>;
};

const mapStateToProps = state => ({
  cards: state.auth.currentUser?.profile?.cards || []
});

const mapDispatchToProps = {
  createQRCode
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateQRCodeModal);